/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JobDto } from '../models/job-dto';
import { JobDtoListBaseResponse } from '../models/job-dto-list-base-response';

@Injectable({
  providedIn: 'root',
})
export class ExcelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiExcelProcessJobsPost
   */
  static readonly ApiExcelProcessJobsPostPath = '/api/Excel/process-jobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessJobsPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsPost$Plain$Response(params?: {
    refuelsOnly?: boolean;
    useMappings?: boolean;
    generateAllRefuels?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<JobDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessJobsPostPath, 'post');
    if (params) {
      rb.query('refuelsOnly', params.refuelsOnly, {});
      rb.query('useMappings', params.useMappings, {});
      rb.query('generateAllRefuels', params.generateAllRefuels, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessJobsPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsPost$Plain(params?: {
    refuelsOnly?: boolean;
    useMappings?: boolean;
    generateAllRefuels?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<JobDtoListBaseResponse> {

    return this.apiExcelProcessJobsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<JobDtoListBaseResponse>) => r.body as JobDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessJobsPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsPost$Json$Response(params?: {
    refuelsOnly?: boolean;
    useMappings?: boolean;
    generateAllRefuels?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<JobDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessJobsPostPath, 'post');
    if (params) {
      rb.query('refuelsOnly', params.refuelsOnly, {});
      rb.query('useMappings', params.useMappings, {});
      rb.query('generateAllRefuels', params.generateAllRefuels, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessJobsPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsPost$Json(params?: {
    refuelsOnly?: boolean;
    useMappings?: boolean;
    generateAllRefuels?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<JobDtoListBaseResponse> {

    return this.apiExcelProcessJobsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<JobDtoListBaseResponse>) => r.body as JobDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiExcelProcessJobsDynamicPost
   */
  static readonly ApiExcelProcessJobsDynamicPostPath = '/api/Excel/process-jobs-dynamic';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessJobsDynamicPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsDynamicPost$Plain$Response(params?: {
    refuelsOnly?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<JobDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessJobsDynamicPostPath, 'post');
    if (params) {
      rb.query('refuelsOnly', params.refuelsOnly, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessJobsDynamicPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsDynamicPost$Plain(params?: {
    refuelsOnly?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<JobDtoListBaseResponse> {

    return this.apiExcelProcessJobsDynamicPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<JobDtoListBaseResponse>) => r.body as JobDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessJobsDynamicPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsDynamicPost$Json$Response(params?: {
    refuelsOnly?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<JobDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessJobsDynamicPostPath, 'post');
    if (params) {
      rb.query('refuelsOnly', params.refuelsOnly, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessJobsDynamicPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessJobsDynamicPost$Json(params?: {
    refuelsOnly?: boolean;
    body?: { 'formFile'?: Blob }
  }): Observable<JobDtoListBaseResponse> {

    return this.apiExcelProcessJobsDynamicPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<JobDtoListBaseResponse>) => r.body as JobDtoListBaseResponse)
    );
  }

  /**
   * Path part for operation apiExcelUploadJobsPost
   */
  static readonly ApiExcelUploadJobsPostPath = '/api/Excel/upload-jobs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelUploadJobsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelUploadJobsPost$Plain$Response(params?: {
    refuelsOnly?: boolean;
    generateAllRefuels?: boolean;
    body?: Array<JobDto>
  }): Observable<StrictHttpResponse<JobDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelUploadJobsPostPath, 'post');
    if (params) {
      rb.query('refuelsOnly', params.refuelsOnly, {});
      rb.query('generateAllRefuels', params.generateAllRefuels, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelUploadJobsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelUploadJobsPost$Plain(params?: {
    refuelsOnly?: boolean;
    generateAllRefuels?: boolean;
    body?: Array<JobDto>
  }): Observable<JobDtoListBaseResponse> {

    return this.apiExcelUploadJobsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<JobDtoListBaseResponse>) => r.body as JobDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelUploadJobsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelUploadJobsPost$Json$Response(params?: {
    refuelsOnly?: boolean;
    generateAllRefuels?: boolean;
    body?: Array<JobDto>
  }): Observable<StrictHttpResponse<JobDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelUploadJobsPostPath, 'post');
    if (params) {
      rb.query('refuelsOnly', params.refuelsOnly, {});
      rb.query('generateAllRefuels', params.generateAllRefuels, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JobDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelUploadJobsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelUploadJobsPost$Json(params?: {
    refuelsOnly?: boolean;
    generateAllRefuels?: boolean;
    body?: Array<JobDto>
  }): Observable<JobDtoListBaseResponse> {

    return this.apiExcelUploadJobsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<JobDtoListBaseResponse>) => r.body as JobDtoListBaseResponse)
    );
  }

}
